import React, { memo, Fragment } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space } from '@redlink/components/atoms';
import { NavBarItem } from '@redlink/components/muscles';

export const NavBar = memo(({ isWhite, onItemPressed, items }) => {
  const { styles } = useStyle();
  return (
    <View style={styles.container}>
      {items.map(({ title, key }, index) => (
        <Fragment key={index}>
          <NavBarItem
            {...{ title, isWhite }}
            onPress={() => onItemPressed(key)}
          />
          <Space />
        </Fragment>
      ))}
    </View>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
}));
